
import { HelpTip } from '../../ui/HelpTip';
import { NotionSelect } from '../../ui/notion/NotionSelect';
import { useCalendarSharingStore } from '../../../lib/stores/calendarSharingStore';
import { useSettingsStore } from '../../../lib/stores/settingsStore';
import { PERSON_COLORS, colorOfPerson, resetPersonColor, setPersonColor } from '../../../lib/calendar/profile/appearance';

const MODES = [
  { value: 'person', label: 'Per persona' },
  { value: 'type', label: 'Per tipo' },
];
const SEP = 'border-t border-[rgba(55,53,47,0.09)] dark:border-white/10';

export function AppearanceTab() {
  const { prefs, setPrefs, people, ctx } = useCalendarSharingStore();
  const orgMode = (useSettingsStore.getState().settings as any)?.calendar_settings?.color_mode;
  const mode = prefs.color_mode || orgMode || 'person';
  const ordered = people.map(p => p.id);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between gap-2 px-1.5">
        <span className="flex items-center gap-1.5 text-xs font-medium text-[#37352F] dark:text-white">
          Come colorare gli appuntamenti
          <HelpTip
            title="Colore per persona o per tipo"
            text="Per persona: ogni calendario ha il suo colore, così vedi subito di chi è un appuntamento. Per tipo: il colore dipende dal tipo di task (videochiamata, sopralluogo...) e il nome del collega resta scritto."
            example="Con 'Per persona' gli appuntamenti di Giulia sono tutti verdi. Con 'Per tipo' tutte le videochiamate sono viola, di chiunque siano."
          />
        </span>
        <NotionSelect variant="flat" aria-label="Come colorare gli appuntamenti" value={mode} options={MODES} onChange={e => void setPrefs({ color_mode: e.target.value as 'person' | 'type' })} />
      </div>

      <div className={`${SEP} pt-3`}>
        <div className="mb-1 flex items-center gap-1.5 px-1.5 text-xs font-medium text-[#787774]">
          Colore dei colleghi
          <HelpTip
            title="Il colore dei colleghi"
            text="Scegli il colore con cui vedi ogni calendario. È una scelta solo tua: i colleghi continuano a vedere i colori che hanno scelto loro."
            example="Se due colleghi hanno colori troppo simili, cambi quello di uno: nessun altro se ne accorge."
          />
        </div>
        {mode === 'type' && <p className="mb-1 px-1.5 text-[11px] text-[#787774]">Con la colorazione per tipo questi colori restano nascosti, ma li ritrovi se torni a 'Per persona'.</p>}
        {people.map(p => {
          const color = colorOfPerson(p.id, ordered, prefs.person_colors);
          const custom = !!prefs.person_colors?.[p.id];
          return (
            <div key={p.id} className="flex min-h-[32px] items-center gap-2 rounded px-1.5 py-0.5 hover:bg-[rgba(55,53,47,0.04)] dark:hover:bg-white/[0.04]">
              <span className="h-2.5 w-2.5 flex-shrink-0 rounded-full" style={{ background: color }} />
              <span className="min-w-[120px] flex-1 truncate text-[13px] text-[#37352F] dark:text-white">{p.name}{p.id === ctx?.meId ? ' (io)' : ''}</span>
              <div className="flex flex-shrink-0 gap-1">
                {PERSON_COLORS.map(c => (
                  <button key={c} type="button" aria-label={`Colore ${c}`} onClick={() => void setPrefs({ person_colors: setPersonColor(prefs.person_colors, p.id, c) })}
                    className={`h-4 w-4 rounded-full ${c.toUpperCase() === color.toUpperCase() ? 'ring-2 ring-offset-1 ring-[#37352F]' : ''}`} style={{ background: c }} />
                ))}
              </div>
              {custom && <button type="button" onClick={() => void setPrefs({ person_colors: resetPersonColor(prefs.person_colors, p.id) })} className="rounded px-1.5 text-[12px] text-[#787774] hover:bg-[rgba(55,53,47,0.08)]">Automatico</button>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
